import { _ as d } from "./index.es251.js";
import { _ as I } from "./index.es252.js";
import { _ as B } from "./index.es253.js";
import { _ as F } from "./index.es254.js";
import { _ as O } from "./index.es255.js";
import { _ as L } from "./index.es256.js";
import { _ as M } from "./index.es257.js";
import { _ as x } from "./index.es258.js";
import { _ as h } from "./index.es259.js";
import { _ as w } from "./index.es260.js";
import { _ as D } from "./index.es101.js";
import { _ as G } from "./index.es261.js";
import { _ as K } from "./index.es262.js";
import { _ as N } from "./index.es263.js";
import { _ as U } from "./index.es264.js";
import { i as P } from "./index.es265.js";
import { i as R } from "./index.es266.js";
import { i as V } from "./index.es267.js";
import { i as W } from "./index.es268.js";
import { i as Y } from "./index.es269.js";
import { k as q } from "./index.es270.js";
import { k as H } from "./index.es271.js";
var J = d, Q = I, X = B, Z = F, $ = O, k = L, u = M, z = x, v = h, rr = w, or = D, tr = G, ar = K, ir = N, er = U, nr = P, sr = R, fr = V, gr = W, mr = Y, pr = q, _r = H, cr = 1, yr = 2, br = 4, A = "[object Arguments]", Tr = "[object Array]", Ar = "[object Boolean]", jr = "[object Date]", lr = "[object Error]", j = "[object Function]", Cr = "[object GeneratorFunction]", Er = "[object Map]", Sr = "[object Number]", l = "[object Object]", dr = "[object RegExp]", Ir = "[object Set]", Br = "[object String]", Fr = "[object Symbol]", Or = "[object WeakMap]", Lr = "[object ArrayBuffer]", Mr = "[object DataView]", xr = "[object Float32Array]", hr = "[object Float64Array]", wr = "[object Int8Array]", Dr = "[object Int16Array]", Gr = "[object Int32Array]", Kr = "[object Uint8Array]", Nr = "[object Uint8ClampedArray]", Ur = "[object Uint16Array]", Pr = "[object Uint32Array]", o = {};
o[A] = o[Tr] = o[Lr] = o[Mr] = o[Ar] = o[jr] = o[xr] = o[hr] = o[wr] = o[Dr] = o[Gr] = o[Er] = o[Sr] = o[l] = o[dr] = o[Ir] = o[Br] = o[Fr] = o[Kr] = o[Nr] = o[Ur] = o[Pr] = !0;
o[lr] = o[j] = o[Or] = !1;
function _(r, n, s, C, g, a) {
  var t, m = n & cr, p = n & yr, E = n & br;
  if (s && (t = g ? s(r, C, g, a) : s(r)), t !== void 0)
    return t;
  if (!gr(r))
    return r;
  var c = nr(r);
  if (c) {
    if (t = ar(r), !m)
      return u(r, t);
  } else {
    var f = tr(r), y = f == j || f == Cr;
    if (sr(r))
      return k(r, m);
    if (f == l || f == A || y && !g) {
      if (t = p || y ? {} : er(r), !m)
        return p ? v(r, $(t, r)) : z(r, Z(t, r));
    } else {
      if (!o[f])
        return g ? r : {};
      t = ir(r, f, m);
    }
  }
  a || (a = new J());
  var b = a.get(r);
  if (b)
    return b;
  a.set(r, t), mr(r) ? r.forEach(function(i) {
    t.add(_(i, n, s, i, r, a));
  }) : fr(r) && r.forEach(function(i, e) {
    t.set(e, _(i, n, s, e, r, a));
  });
  var S = E ? p ? or : rr : p ? _r : pr, T = c ? void 0 : S(r);
  return Q(T || r, function(i, e) {
    T && (e = i, i = r[e]), X(t, e, _(i, n, s, e, r, a));
  }), t;
}
var so = _;
export {
  so as _
};
//# sourceMappingURL=index.es95.js.map
